import {
  PRODUCTCATEGORY_LOADING,
  GET_PRODUCTCATEGORY,
  GET_PRODUCTCATEGORY_SUCCESS,
  GET_PRODUCTCATEGORY_FAIL,
  ADD_PRODUCTCATEGORY_SUCCESS,
  ADD_PRODUCTCATEGORY_FAIL,
  DELETE_PRODUCTCATEGORY_SUCCESS,
  DELETE_PRODUCTCATEGORY_FAIL,
  UPDATE_PRODUCTCATEGORY_SUCCESS,
  UPDATE_PRODUCTCATEGORY_FAIL,
  PRODUCTCATEGORY_RESET
} from "./actionType";

const INIT_STATE = {
  productCategories: [],
  error: {},
};

const ProductCategory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTCATEGORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTCATEGORY:
          return {
            ...state,
            productCategories: action.payload.data,
            isProductCategoryCreated: false,
            isProductCategorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTCATEGORY_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTCATEGORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductCategoryCreated: false,
            isProductCategorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTCATEGORY: {
      return {
        ...state,
        isProductCategoryCreated: false,
        loading: true,
      };
    }

    case PRODUCTCATEGORY_LOADING: {
      return {
        ...state,
        isProductCategoryCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTCATEGORY_SUCCESS:
      return {
        ...state,
        isProductCategoryCreated: true,
        loading: false,
        productCategories: [action.payload.data, ...state.productCategories],
      };

    case ADD_PRODUCTCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        productCategories: state.productCategories.filter(
          productCategory => productCategory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        productCategories: state.productCategories.map(productCategory =>
          productCategory.id.toString() === action.payload.data.id.toString() ? { ...productCategory, ...action.payload.data } : productCategory
        ),
      };

    case UPDATE_PRODUCTCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTCATEGORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductCategory;